import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authentocationService: AuthenticationService,
    private router: Router) { }

  ngOnInit(): void {

    this.authentocationService.logOut().subscribe(
      response => {
        // console.log('Logged out successfully', response);
        // Redirect to login page or perform other actions
      },
      error => {
        console.error('Logout failed', error);
      }
    );    this.router.navigate(['/login']);
  }

}
